import { useSessionStorageState, clearCache } from 'ahooks'

export default function useIdentity() {
  const [ uid, uidDispatch ] = useSessionStorageState<string>(`${APP_ENV.db}:uid`)
  const [ user, userDispatch ] = useSessionStorageState<any>(`${APP_ENV.db}:user`)
  const [ token, tokenDispatch ] = useSessionStorageState<string>(`${APP_ENV.db}:token`)

  const clear = R.compose(
    R.tap(uidDispatch),
    R.tap(userDispatch),
    R.tap(tokenDispatch),
  )

  const dispatch = R.cond([
    [R.equals('uid'), R.always(uidDispatch)],
    [R.equals('user'), R.always(userDispatch)],
    [R.equals('token'), R.always(tokenDispatch)],
  ])

  return {
    uid,
    user,
    token,
    isLogined: () => token != null,
    clear: () => [ clear(undefined), clearCache('/menu/my') ],
    dispatch: (type: string, data: any) => dispatch?.(type)?.(data),
    hasPermission: (code: string | string[]) => R.any((permission: string) => R.is(Array, code) ? code.includes(permission) : code == permission, R.defaultTo([], user?.permissions)),
  }
}
